import { mapToList } from "./utils";

// 类型码与后端一致：1 基准、2 微调、3 复购、4 注意事项、5 套现、6 人工干预、7 拒单。
export const EnumMachineRuleType = {
  BASE: 1,
  FINE_TUNE: 2,
  REPURCHASE: 3,
  ATTENTION: 4,
  CASH_OUT: 5,
  MANUAL: 6,
  REJECT: 7,
};

export const MachineRuleTypeToTextMap = new Map([
  [EnumMachineRuleType.BASE, "基准规则"],
  [EnumMachineRuleType.FINE_TUNE, "微调规则"],
  [EnumMachineRuleType.ATTENTION, "注意事项规则"],
  [EnumMachineRuleType.CASH_OUT, "套现规则"],
  [EnumMachineRuleType.REPURCHASE, "复购规则"],
  [EnumMachineRuleType.MANUAL, "人工干预规则"],
  [EnumMachineRuleType.REJECT, "拒单规则"],
]);

export const MachineRuleTypeList = mapToList(MachineRuleTypeToTextMap);

// 微调、套现和人工干预使用组级首付比浮动字段。
export const ADJUST_RULE_TYPES = [
  EnumMachineRuleType.FINE_TUNE,
  EnumMachineRuleType.CASH_OUT,
  EnumMachineRuleType.MANUAL,
];

export const hasAdjustFields = (ruleType) =>
  ADJUST_RULE_TYPES.includes(ruleType);

// 规则类型标签的文字色与背景色。
export const MachineRuleTypeToColorMap = new Map([
  [EnumMachineRuleType.BASE, { color: "#5B8FF9", background: "#EAF2FF" }],
  [EnumMachineRuleType.FINE_TUNE, { color: "#F0A44A", background: "#FDF3E7" }],
  [EnumMachineRuleType.ATTENTION, { color: "#3FD0C9", background: "#E7FAF8" }],
  [EnumMachineRuleType.CASH_OUT, { color: "#F2807F", background: "#FDEDEC" }],
  [EnumMachineRuleType.REPURCHASE, { color: "#6FCF7F", background: "#EAF8EC" }],
  [EnumMachineRuleType.MANUAL, { color: "#A98BF0", background: "#F2EDFD" }],
  [EnumMachineRuleType.REJECT, { color: "#FF165D", background: "#FCD4E0" }],
]);

// 未知规则类型使用中性灰。
const FALLBACK_MACHINE_RULE_TYPE_COLOR = {
  color: "#909399",
  background: "#F4F4F5",
};

export function getMachineRuleTypeColor(type) {
  return (
    MachineRuleTypeToColorMap.get(Number(type)) || FALLBACK_MACHINE_RULE_TYPE_COLOR
  );
}

// 策略来源编号保持后端定义，5（智租）暂不上线。
export const EnumStrategySource = {
  SYSTEM: 1,
  BAIRONG: 2,
  YOUFEN: 3,
  XINYAN: 4,
  ZUANDUN: 6,
};

export const StrategySourceToTextMap = new Map([
  [EnumStrategySource.SYSTEM, "系统"],
  [EnumStrategySource.BAIRONG, "百融"],
  [EnumStrategySource.YOUFEN, "优分"],
  [EnumStrategySource.XINYAN, "新颜"],
  [EnumStrategySource.ZUANDUN, "租安盾"],
]);

export const StrategySourceList = mapToList(StrategySourceToTextMap);
